<template>
  <div class="products category-leaflet">
    <Breadcrumb :items="breadcrumbs" />
    <category-block
      :target="category"
      position="position1"
      class="category-block category-block-header-1"
    />
    <v-container class="py-0">
      <CategoryTitle
        :category="category"
        :selectedCategory="selectedCategory"
        :count="count"
        :key="category.categoryId"
      />
    </v-container>

    <v-container v-if="categoryId">
      <ProductListGrid
        :fluid="$vuetify.breakpoint.xsOnly"
        :parentCategoryId="category.categoryId"
        :categoryId="categoryId"
        :key="category.categoryId"
        :hidePromoFilter="true"
        hideFilterString="Categorie,Main Term"
        @productsCount="updateCount"
      />
    </v-container>
    <template v-else>
      <v-container
        v-for="subCategory in category.children"
        :key="subCategory.categoryId"
      >
        <product-list-slider
          :title="subCategory.name"
          :fetchCategoryId="category.categoryId"
          :categoryId="subCategory.categoryId"
          :categoryPath="category.slug"
          :paginationClass="`swiper-pagination-${subCategory.categoryId}`"
          cols="auto"
          sm="2"
          md="2"
          lg="3"
          xl="4"
        >
        </product-list-slider>
      </v-container>
    </template>
    <category-block
      :target="category"
      position="position10"
      class="category-block category-block-footer-1"
    />
  </div>
</template>
<style lang="scss">
.category-leaflet {
  .category-block-title {
    font-size: 16px;
    font-weight: bold;
    line-height: 1rem;
    text-align: center;
    justify-content: center;
    word-break: break-word;
  }
  .center-img {
    margin-right: auto;
    margin-left: auto;
  }
}
</style>
<script>
// @ is an alias to /src
import CategoryTitle from "@/components/category/CategoryTitle.vue";

import Breadcrumb from "@/components/navigation/Breadcrumb.vue";
// import CategoryBlock from "@/components/categoryBlock/CategoryBlock.vue";
import ProductListGrid from "@/components/product/ProductListGrid.vue";

import categoryMixins from "~/mixins/category";
import toNumber from "lodash/toNumber";
import ProductListSlider from "@/components/categoryBlock/elements/ProductListSlider.vue";

export default {
  name: "CategoryLeafletSlider",
  mixins: [categoryMixins],
  data() {
    return { categoryId: null, count: null };
  },
  components: {
    CategoryTitle,
    Breadcrumb,
    // CategoryBlock,
    ProductListSlider,
    ProductListGrid
  },
  computed: {
    breadcrumbs() {
      let breadCrumbs = [];

      breadCrumbs.push({
        to: { name: "Home" },
        text: "Home",
        exact: true
      });
      breadCrumbs.push({
        to: {
          name: "Category",
          params: {
            pathMatch: this.category.slug
          }
        },
        text: this.category.name,
        exact: true
      });
      if (this.categoryId) {
        let subCategory = this.category.children.find(
          cat => cat.categoryId == this.categoryId
        );
        breadCrumbs.push({
          to: {
            name: "Category",
            params: {
              pathMatch: this.category.slug
            },
            query: { categoryId: subCategory.categoryId }
          },
          text: subCategory.name,
          exact: true
        });
      }
      return breadCrumbs;
    },
    selectedCategory() {
      if (this.categoryId) {
        return this.category.children.find(
          item => item.categoryId == this.categoryId
        );
      } else {
        return null;
      }
    }
  },
  methods: {
    updateCount(count) {
      this.count = count;
    }
  },
  created() {
    this.categoryId = toNumber(this.$route.query.categoryId);
  },
  watch: {
    async "$route.query.categoryId"() {
      this.categoryId = this.$route.query.categoryId;
    }
  }
};
</script>
